var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClinic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 23,
    fill: "#3288CD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.602 19.0308H30.8603C31.9055 19.0308 32.7529 19.8782 32.7529 20.9234V24.7085C32.7529 25.7538 31.9055 26.6011 30.8603 26.6011H26.602V30.8594C26.602 31.9047 25.7546 32.752 24.7094 32.752H20.9242C19.879 32.752 19.0317 31.9047 19.0317 30.8594V26.6011H14.7734C13.7282 26.6011 12.8809 25.7538 12.8809 24.7085V20.9234C12.8809 19.8782 13.7282 19.0308 14.7734 19.0308H19.0317V14.7726C19.0317 13.7273 19.879 12.88 20.9242 12.88H24.7094C25.7546 12.88 26.602 13.7273 26.602 14.7726V19.0308ZM24.7094 19.9771V14.7726H20.9242V19.9771C20.9242 20.4997 20.5006 20.9234 19.978 20.9234H14.7734V24.7085H19.978C20.5006 24.7085 20.9242 25.1322 20.9242 25.6548V30.8594H24.7094V25.6548C24.7094 25.1322 25.1331 24.7085 25.6557 24.7085H30.8603V20.9234H25.6557C25.1331 20.9234 24.7094 20.4997 24.7094 19.9771Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinic);
export default __webpack_public_path__ + "static/media/clinic.49dd32c48afd812869a14ff5e2579a14.svg";
export { ForwardRef as ReactComponent };